module.exports = __webpack_public_path__ + "static/media/gf.4904eaca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/gf.svg
// module id = 125
// module chunks = 0